import type { CSSObject, Theme } from '@mui/material'
import type { InterstitialAvailability } from 'features/inventory/domain/types/interstitialAvailability'

export type InterstitialAvailabilityColor = {
  availability: InterstitialAvailability
  theme: Theme
}

export const interstitialAvailabilityColor = ({
  availability,
  theme,
}: InterstitialAvailabilityColor): CSSObject['color'] => {
  const {
    palette: {
      error: { main: error },
      success: { main: success },
    },
  } = theme

  switch (availability) {
    case 'available': {
      return success
    }
    case 'notAvailable': {
      return error
    }
  }
}
